export default{
    lista:{
        method:'get',
        url:'tabelapreco/lista'
    },
    pesquisa:{
        method:'get',
        url:'tabelapreco/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'tabelapreco/cadastro'
    },
    delete:{
        method:'delete',
        url:'tabelapreco/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'tabelapreco/editar{/id}'
    },
    update:{
        method:'post',
        url:'tabelapreco/update'
    },
    configuracaocartaoponto:{
        method:'post',
        url:'tabelapreco/configuracao/cartaoponto'
    },
    mover:{
        method:'post',
        url:'tabelapreco/mover'
    },
    padrao:{
        method:'post',
        url:'tabela/preco/padrao'
    },
    duplica:{
        method:'get',
        url:'tabela/preco/duplica{/id}'
    },
    matricula:{
        method:'get',
        url:'tabela/preco/matricula'
    },
}